require('../bootstrap');

import { createApp } from 'vue';
import mainComponent from '../components/user/evaluateForm.vue';

const app = createApp(mainComponent)

app.mount('#app')